import { useEffect, useRef } from "react";
import { refreshToken } from "../utils/methods";

const REFRESH_INTERVAL_MS = 10 * 60 * 1000;
const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];

const useTokenRefresher = () => {
  const activityRef = useRef(false);

  useEffect(() => {
    const markActive = () => {
      activityRef.current = true;
    };

    ACTIVITY_EVENTS.forEach((evt) => {
      window.addEventListener(evt, markActive, { passive: true });
    });

    const tick = async () => {
      if (!activityRef.current) return;
      if (!localStorage.getItem("authToken")) return;
      activityRef.current = false;
      await refreshToken();
    };

    const intervalId = setInterval(tick, REFRESH_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
      ACTIVITY_EVENTS.forEach((evt) => {
        window.removeEventListener(evt, markActive);
      });
    };
  }, []);
};

export default useTokenRefresher;
